import axios from 'axios';
import type { LocationsDTO } from '@bb/domain/dist/types/dto/OrgController/locations';

const locations = async () => {
  const { data } = await axios.get<LocationsDTO>('/org/locations');

  return data;
};

export default locations;
